export default "__VITE_ASSET__DNjHC5OK__"